import type { ReactNode } from "react";

interface AdminAuthShellProps {
  children: ReactNode;
}

export function AdminAuthShell({ children }: AdminAuthShellProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 gap-5">
      <div className="text-center select-none">
        <p className="font-display font-black text-lg tracking-wide text-foreground">
          IMPROVE<span className="text-primary">YOURSELF</span>
        </p>
        <p className="text-[10px] text-muted-foreground tracking-[0.2em] uppercase mt-0.5">
          Panel Administrativo
        </p>
      </div>
      <div className="w-full max-w-sm bg-card border border-border rounded-xl p-8 shadow-sm">
        {children}
      </div>
    </div>
  );
}
